import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreateDailyCheckInForm from '../CreateDailyCheckInForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function CreateDailyCheckInListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`สร้างกิจกรรมเช็คอินรายวัน`}
					description="สร้างกิจกรรมเช็คอินรายวัน"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateDailyCheckInForm />
		</div>
	)
}
